import { render, staticRenderFns } from "./EditMaterial.vue?vue&type=template&id=6ba8b80f&scoped=true"
import script from "./EditMaterial.vue?vue&type=script&lang=js"
export * from "./EditMaterial.vue?vue&type=script&lang=js"
import style0 from "./EditMaterial.vue?vue&type=style&index=0&id=6ba8b80f&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ba8b80f",
  null
  
)

export default component.exports